import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined';
import FaceOutlinedIcon from '@mui/icons-material/FaceOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import type { SvgIconComponent } from '@mui/icons-material';

import type { AccountProfile } from '../api/types';

export type NavigationItem = {
  path: string;
  label: string;
  icon: SvgIconComponent;
  allow: AccountProfile['role'][];
};

export type NavigationGroup = {
  heading: string | null;
  items: NavigationItem[];
};

export const NAVIGATION: NavigationGroup[] = [
  {
    heading: null,
    items: [
      {
        path: '/',
        label: 'Prehľad',
        icon: SpaceDashboardOutlinedIcon,
        allow: ['SUPPORT', 'CONTENT_EDITOR', 'SUPERUSER'],
      },
    ],
  },
  {
    heading: 'Používatelia',
    items: [
      { path: '/accounts', label: 'Účty', icon: PeopleOutlineIcon, allow: ['SUPPORT', 'SUPERUSER'] },
      { path: '/children', label: 'Deti', icon: FaceOutlinedIcon, allow: ['SUPPORT', 'SUPERUSER'] },
    ],
  },
  {
    heading: 'Obsah',
    items: [
      {
        path: '/content-health',
        label: 'Zdravie obsahu',
        icon: MonitorHeartOutlinedIcon,
        allow: ['SUPPORT', 'CONTENT_EDITOR', 'SUPERUSER'],
      },
      {
        path: '/challenges',
        label: 'Katalóg úloh',
        icon: ExtensionOutlinedIcon,
        allow: ['SUPPORT', 'CONTENT_EDITOR', 'SUPERUSER'],
      },
      {
        path: '/achievements',
        label: 'Ocenenia',
        icon: EmojiEventsOutlinedIcon,
        allow: ['SUPPORT', 'CONTENT_EDITOR', 'SUPERUSER'],
      },
      {
        path: '/reading',
        label: 'Príbehy',
        icon: MenuBookOutlinedIcon,
        allow: ['SUPPORT', 'CONTENT_EDITOR', 'SUPERUSER'],
      },
    ],
  },
  {
    heading: 'Prevádzka',
    items: [
      {
        path: '/plans',
        label: 'Predplatné',
        icon: WorkspacePremiumOutlinedIcon,
        allow: ['SUPPORT', 'SUPERUSER'],
      },
      { path: '/backups', label: 'Zálohy', icon: BackupOutlinedIcon, allow: ['SUPERUSER'] },
      { path: '/audit', label: 'Audit', icon: HistoryOutlinedIcon, allow: ['SUPERUSER'] },
    ],
  },
];
